import React from "react"
import { Helmet } from "react-helmet"
import Phone from "../../components/Shared/Phone.js"
import Email from "../../components/Shared/Email.js"
import Social from "../../components/Social/Social.js"
import Directions from "../../components/Shared/Directions"
import Reservations from "../../components/Shared/Reservations"
const classes = require('./Contact.module.scss')
const image1 = require('../../assets/images/mmExt5.jpg')
const image2 = require('../../assets/images/mmFront3.jpg')

const contact = () => {
  return (
    <div className={classes.Contact}>
      <Helmet>
        <title>Contact Mile Marker 158 Dockside</title>
        <meta name="description" content="Mile Marker 158 Dockside is located dockside at the Springhill Suites Hotel at The Wharf in Orange Beach, Alabama. We serve delicious food 7 days a week!" />
      </Helmet>

      <div className={classes.stackSec}>
        <div className={classes.textBox1}><h1>Contact Us</h1></div>
        <div className={[classes.sectionWrap, classes.inside14].join(' ')}>
          <div className={classes.stackTop}>
            <div className={classes.tallImg}>
              <img src={image1} alt="View from the Mile Marker 158 Dockside outdoor seating area" className={[classes.imgResponsive, classes.tallImgX].join(' ')} />
            </div>
            
            <div className={classes.longImg}>
              <img src={image2} alt="Entrance to Mile Marker 158 Dockside at The Wharf" className={[classes.imgResponsive, classes.longImgX].join(' ')} />
            </div>
          </div>
          
          <div className={classes.textBox2}>
            <div className={[classes.boxWrap, classes.flexGroup].join(' ')}>
              <div className={[classes.group, classes.g1].join(' ')}>
                <div className={[classes.item, classes.ihours].join(' ')}>
                  <p className={classes.hours}>
                    <span>Hours</span><br/> 
                    <b>Sunday-Wednesday:</b> 11am-9pm<br/>
                    <b>Thursday-Saturday:</b> 11am-10pm<br/> 
                  </p>
                </div>
                
                <div className={[classes.item, classes.iphone].join(' ')}><p><span>Phone:</span><br/><Phone /></p></div>
                <div className={[classes.item, classes.iemail].join(' ')}><p><span>Email:</span><br/><Email /></p></div>
              </div>

              <div className={[classes.group, classes.g2].join(' ')}>
                <div className={[classes.item, classes.iaddress].join(' ')}>
                  <p><span>Address:</span><br/>4673 Wharf Parkway W<br/>
                  Suite B<br/>
                  Orange Beach, AL 36561</p>
                  
                  <div className={classes.buttonRow}>
                    <Directions addClass="hoverLink" />
                    <Reservations addClass="hoverLink" addClass3="contactPage" />
                  </div>
                </div>

                <div className={[classes.item, classes.isocials].join(' ')}>
                  <p><span>Follow Us:</span></p>
                  <Social where="contact" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={classes.borderRow}><div className={classes.inside15}><hr /></div></div>
    </div>
  )
}
export default contact